export default __webpack_public_path__ + "static/media/search.648936cc.png";